<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter"
      :style="headerStyle"
    ></parallax>
    <div class="main main-raised">
      <div class="section profile-content">
        <div class="container">
          <div class="full-control whyUs">
            <div class="list">
              <v-row class="whyUsInner">
                <v-col cols="12">
                  <h2>Quem Somos</h2>
                </v-col>
                <v-col cols="8" style="text-align: justify">
                  <p class="classP">
                    A CenterGeo foi fundada em 2017 em Poços de Caldas/MG, por
                    um grupo de sócios com vasta experiência em engenharia,
                    geotecnia, administração e know-how no mercado.
                  </p>
                  <p class="classP">
                    Com o intuito de atender com maior agilidade nossos
                    parceiros, em 2019 a CenterGeo passou a ser sediada em
                    Contagem/MG.
                  </p>
                  <p class="classP">
                    Focamos em soluções com produtos de alta qualidade, baixo
                    custo e comprometimento com prazos. Com dinamismo,
                    excelência, técnica e certificados, fornecendo soluções em
                    geossintéticos, tais como geotêxtil, tubos drenos,
                    eletrodutos, biomantas, geomembranas, camisas drenantes,
                    fibras para concretos, manta para cura de concreto,
                    geocompostos, dentre outros.
                  </p>
                  <p class="classP">
                    Desta forma, a CenterGeo se apresenta como parceira para
                    atender pequenas, médias e grandes obras na construção
                    civil.
                  </p>
                </v-col>
                <v-col cols="4">
                  <img src="../assets/institucional/institucional.jpg" />
                </v-col>
              </v-row>
              <div class="whyUs">
                <v-row class="whyUsInner">
                  <v-col cols="12">
                    <h2>Missão</h2>
                  </v-col>
                  <v-col cols="12" style="text-align: justify">
                    <p class="classP">
                      A CenterGeo foca desde a gestão, qualificação, aquisição,
                      venda, entrega, pós venda e satisfação dos nossos
                      parceiros.
                    </p>
                    <p class="classP">
                      A responsabilidade com a qualidade e eficiência nos
                      atendimentos dos nossos parceiros, são o nosso foco.
                    </p>
                    <p class="classP">
                      Procuramos fazer o diferencial no mercado, com ética e
                      comprometimento com a qualidade dos nossos serviços
                      prestados.
                    </p>
                  </v-col>
                </v-row>
              </div>
              <div class="whyUs">
                <v-row class="whyUsInner">
                  <v-col cols="12">
                    <h2>Certificados</h2>
                  </v-col>
                  <v-col cols="12" style="text-align: justify">
                    <p class="classP">
                      A CenterGeo visa trabalhar com geossintéticos de
                      qualidade, onde a capacidade produtiva e a experiência,
                      aliadas à ética e ao comprometimento com as questões
                      sociais e ambientais, é primordial na visão de trabalho da
                      CenterGeo. Assim, a CenterGeo fornece materiais com
                      Certificação ISO 9001 e adequados à Conformidade Europeia
                      (CE), com as exigências dentro das Normas conforme cada
                      produto específico.
                    </p>
                  </v-col>
                </v-row>
              </div>
              <v-row class="mb-6">
                <v-col class="classCol">
                  <v-row>
                    <md-button class="md-fab md-plain">
                      <fa-icon :icon="['fas', 'phone-volume']" size="2x" />
                    </md-button>
                    <h5 class="classh5">Atende todo território Brasileiro</h5>
                  </v-row>

                  <v-row>
                    <md-button class="md-fab md-plain">
                      <fa-icon :icon="['fas', 'truck']" size="2x" />
                    </md-button>
                    <h5 class="classh5">Produtos de pronta entrega</h5>
                  </v-row>

                  <v-row>
                    <md-button class="md-fab md-plain">
                      <fa-icon :icon="['fas', 'user-circle']" size="2x" />
                    </md-button>
                    <h5 class="classh5">Atendimento personalizado</h5>
                  </v-row>
                </v-col>
                <v-col class="classCol">
                  <v-row>
                    <md-button class="md-fab md-plain">
                      <fa-icon :icon="['fas', 'check-circle']" size="2x" />
                    </md-button>
                    <h5 class="classh5">Produtos certificados</h5>
                  </v-row>

                  <v-row>
                    <md-button class="md-fab md-plain">
                      <fa-icon :icon="['fas', 'money-bill-alt']" size="2x" />
                    </md-button>
                    <h5 class="classh5">Melhores preços</h5>
                  </v-row>

                  <v-row>
                    <md-button class="md-fab md-plain">
                      <fa-icon :icon="['fab', 'etsy']" size="2x" />
                    </md-button>
                    <h5 class="classh5">
                      Ética e compromisso com seus parceiros
                    </h5>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </div>
      <div class="section" style="background: black">
        <information-footer></information-footer>
      </div>
    </div>
  </div>
</template>

<script>
import InformationFooter from "../components/InformationFooter";

export default {
  components: { InformationFooter },
  bodyClass: "profile-page",
  data() {
    return {};
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/home/fundo.png"),
    },
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.projectImg {
  width: 200px;
  padding: 10px;
}

.profile-tabs::v-deep {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img {
      margin-bottom: 2.142rem;
    }
  }
}

.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.md-card .md-card-header {
  margin: -20px 20px 15px;
  border-radius: 3px;
  padding: 20px 0;
  box-shadow: unset;
  background-color: transparent;
}

.content {
  justify-content: flex-end;
}

.paragrafo {
  white-space: break-spaces;
  text-align: justify;
}

.md-button {
  width: 70px;
  height: 70px;
}

.md-button,
.md-button:hover,
.md-button:focus,
.md-button:active {
  background-color: #f7b71e !important;
  box-shadow: none;
}

.classh5 {
  padding: 20px;
  font-size: 1rem;
}

.classCol {
  margin-left: 45px;
  margin-right: 45px;
}

.classP {
  font-size: 1rem;
}
</style>
